import { SkeletonLoader } from '@/components/SkeletonLoader';

type LocationCardLoaderProps = {
  dataTestId: string;
};

export default function LocationCardLoader({
  dataTestId,
}: LocationCardLoaderProps) {
  return (
    <div className="flex flex-col bg-white">
      <SkeletonLoader dataTestId={`${dataTestId}-image`} />

      <div className="flex flex-col items-stretch flex-1 p-5">
        <div className="flex flex-col justify-center flex-1 gap-1">
          <SkeletonLoader
            dataTestId={`${dataTestId}-text-1`}
            className="w-[30%] h-6 mb-1"
          />
          <SkeletonLoader
            dataTestId={`${dataTestId}-text-2`}
            className="w-[80%] h-8 mb-1"
          />
          <SkeletonLoader
            dataTestId={`${dataTestId}-text-3`}
            className="w-[50%] h-6 mb-1"
          />
          <SkeletonLoader
            dataTestId={`${dataTestId}-text-4`}
            className="w-[70%] h-6 mb-1"
          />
          <SkeletonLoader
            dataTestId={`${dataTestId}-text-5`}
            className="w-[50%] h-6"
          />
        </div>

        <SkeletonLoader
          dataTestId={`${dataTestId}-link`}
          className="self-end w-[30%] h-6"
        />
      </div>
    </div>
  );
}
